import { AxiosResponse } from 'axios';

export * from './colors';
export * from './formats';
export * from './permissions';
export * from './styleGrid';
export * from './content';

export const DEFAULT_TAB_KEY = '1';

// 轉單館
export const DSS_SHOP_LIST = [219469859, 111392667, 143543286];

export const MAX_PAGE_SIZE = 100;
export const V2_MAX_PAGE_SIZE = 50;
export const FIFTY_MINUTE_TIMER_INTERVAL = 1000 * 60 * 15;

export type HandlerFunction = (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
export interface ApiResponse {
  requestURL?: string;
  status?: Number;
  code?: any;
  error?: boolean;
  message?: string;
  data?: any;
  total?: number;
  totalCount?: number;
  per_page?: number;
  next_page_url?: string;
}

export type AxiosApiResponse = AxiosResponse<ApiResponse>;

// TODO: Move to constant/content.
export const EMPTY_SIGN = '-'; 

export const ModalEditParam = {
  Export: 'export',
  Batch: 'batch',
  Status: 'status',
};
